import { baseTheme } from "./baseTheme";
import { darkTheme } from "./darkTheme";
import { lightTheme } from "./lightTheme";

export const createTheme = (colorScheme) => {
  if (colorScheme === "dark") {
    return {
      ...baseTheme,
      ...darkTheme,
    };
  } else {
    return {
      ...baseTheme,
      ...lightTheme,
    };
  }
};
